<template>
    <div>
        <a :href="storeUrl">
            <img class="corpLogo" :src="logoSrc" alt="Best-One Tires">
        </a>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('location');
export default {
    props: {
        logoSrc: String
    },
    computed: {
        ...mapState(['selectedStore']),
        storeUrl: function() {
            return this.selectedStore ? 
            `/store/${this.selectedStore.slugPartner}` :
            '/'
        }
    },
    mounted: function() {
        this.requireSelectedStore();
    },
    methods: {
        ...mapActions(['requireSelectedStore']),
    }
}
</script>